/* Grill King design service pages.

   1. Upgrades the native <select> fields in the design quote form into animated
      listboxes. The native select stays in the DOM as the source of truth, so
      the form still submits exactly the same `contact[...]` values (and keeps
      working when this script fails to load).
   2. Reveals content cards on scroll.

   Both features no-op under prefers-reduced-motion for the animation part only;
   the dropdowns remain functional. */
(function () {
  'use strict';

  // The stylesheet and this script are referenced by both the design service
  // section and the standalone quote form, so guard against a double run.
  if (window.egjDesignServiceInit) return;
  window.egjDesignServiceInit = true;


  function closeAllExcept(current) {
    document.querySelectorAll('.egj-sel.is-open').forEach(function (el) {
      if (el !== current) setOpen(el, false);
    });
  }

  function setOpen(root, open) {
    var button = root.querySelector('.egj-sel__button');
    var panel = root.querySelector('.egj-sel__panel');
    if (!button || !panel) return;

    root.classList.toggle('is-open', open);
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      panel.hidden = false;
      // Panels are display:none until shown, so focus must wait a frame.
      requestAnimationFrame(function () {
        var active = panel.querySelector('[aria-selected="true"]') || panel.querySelector('.egj-sel__option');
        if (active) active.focus();
      });
    } else {
      panel.hidden = true;
    }
  }

  function upgradeSelect(select) {
    if (select.dataset.egjUpgraded === 'true' || select.multiple) return;
    select.dataset.egjUpgraded = 'true';

    var root = document.createElement('div');
    root.className = 'egj-sel';

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'egj-sel__button';
    button.setAttribute('aria-haspopup', 'listbox');
    button.setAttribute('aria-expanded', 'false');

    var fieldLabel = select.id ? document.querySelector('label[for="' + select.id + '"]') : null;
    if (fieldLabel) button.setAttribute('aria-label', fieldLabel.textContent.trim());

    var label = document.createElement('span');
    label.className = 'egj-sel__value';
    button.appendChild(label);

    var chevron = document.createElement('span');
    chevron.className = 'egj-sel__chevron';
    chevron.setAttribute('aria-hidden', 'true');
    button.appendChild(chevron);

    var panel = document.createElement('div');
    panel.className = 'egj-sel__panel';
    panel.setAttribute('role', 'listbox');
    panel.hidden = true;

    Array.prototype.forEach.call(select.options, function (option, index) {
      var item = document.createElement('button');
      item.type = 'button';
      item.className = 'egj-sel__option';
      item.setAttribute('role', 'option');
      item.dataset.index = String(index);
      item.textContent = option.textContent;
      item.setAttribute('aria-selected', option.selected ? 'true' : 'false');
      item.style.setProperty('--egj-sel-i', String(index));

      item.addEventListener('click', function () {
        select.selectedIndex = index;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
        setOpen(root, false);
        button.focus();
      });

      panel.appendChild(item);
    });

    function sync() {
      var option = select.options[select.selectedIndex];
      var text = option ? option.textContent.trim() : '';
      label.textContent = text;
      root.classList.toggle('is-placeholder', !option || option.value === '');
      panel.querySelectorAll('.egj-sel__option').forEach(function (item) {
        item.setAttribute('aria-selected', Number(item.dataset.index) === select.selectedIndex ? 'true' : 'false');
      });
    }

    button.addEventListener('click', function () {
      var open = !root.classList.contains('is-open');
      closeAllExcept(root);
      setOpen(root, open);
    });

    root.addEventListener('keydown', function (event) {
      var open = root.classList.contains('is-open');
      if (event.key === 'Escape' && open) {
        setOpen(root, false);
        button.focus();
        event.preventDefault();
        return;
      }
      if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && !open) {
        setOpen(root, true);
        event.preventDefault();
        return;
      }
      if (!open) return;

      var items = Array.prototype.slice.call(panel.querySelectorAll('.egj-sel__option'));
      var pos = items.indexOf(document.activeElement);
      if (event.key === 'ArrowDown') {
        (items[pos + 1] || items[0]).focus();
        event.preventDefault();
      } else if (event.key === 'ArrowUp') {
        (items[pos - 1] || items[items.length - 1]).focus();
        event.preventDefault();
      }
    });

    select.parentNode.insertBefore(root, select);
    root.appendChild(button);
    root.appendChild(panel);
    root.appendChild(select);
    select.classList.add('egj-sel__native');
    select.setAttribute('tabindex', '-1');
    select.setAttribute('aria-hidden', 'true');
    select.addEventListener('change', sync);
    sync();
  }

  function init() {
    document.querySelectorAll('.egj-dsq select.egj-dsq__input').forEach(upgradeSelect);
    // Scroll reveals are handled by the shared motion layer (fp-motion.js).
    // The custom select is injected here, so re-arm motion for the new nodes.
    if (window.fpMotion) window.fpMotion.refresh();
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest('.egj-sel')) closeAllExcept(null);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
